export { Inline } from './Inline';

export type { InlineProps } from './Inline';
